import React from 'react';
import { motion } from 'framer-motion';
const BOOK_COVER_URL = 'https://cdn.magicpatterns.com/uploads/4bvjKmWZd3NtvDruvwvV8w/Portada_para_el_E-book_Por_que_Levantar_tu_autoestima_en_Epocas_de_Crisis.-.png';
export function BookPresentation() {
  return <section className="w-full bg-warm-dark-alt py-20 md:py-28 relative overflow-hidden" data-id="element-32">
      <div className="absolute inset-0 bg-gradient-to-br from-amber/[0.02] via-transparent to-sunset/[0.02] pointer-events-none" data-id="element-33" />

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-34">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-35">
          {/* Book cover */}
          <motion.div initial={{
          opacity: 0,
          x: -40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="flex justify-center" data-id="element-36">
            <motion.div animate={{
            y: [0, -10, 0]
          }} transition={{
            duration: 6,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="relative" data-id="element-37">
              {/* Glow behind book */}
              <div className="absolute -inset-8 bg-amber/10 rounded-3xl blur-3xl pointer-events-none" data-id="element-38" />
              <img src={BOOK_COVER_URL} alt="Portada del eBook: La Importancia de Levantar tu Autoestima en Épocas de Crisis" className="relative w-[260px] sm:w-[320px] md:w-[360px] rounded-lg shadow-book" data-id="element-39" />
            </motion.div>
          </motion.div>

          {/* Text */}
          <motion.div initial={{
          opacity: 0,
          x: 40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.8,
          delay: 0.15,
          ease: 'easeOut'
        }} className="text-center lg:text-left" data-id="element-40">
            <p className="font-body text-amber text-sm uppercase tracking-[0.2em] mb-4" data-id="element-41">
              Te presento
            </p>

            <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold text-cream leading-snug mb-6" data-id="element-42">
              La Importancia de Levantar tu Autoestima{' '}
              <span className="text-amber italic" data-id="element-43">en Épocas de Crisis</span>
            </h2>

            <p className="font-body text-cream-muted/80 text-base sm:text-lg leading-relaxed mb-8" data-id="element-44">
              Un eBook práctico que no solo te explica por qué es crucial elevar
              tu autoestima en tiempos difíciles, sino que te guía a través de
              ejercicios diarios y ejemplos prácticos que puedes aplicar desde
              el primer día.
            </p>

            <a href="https://www.equilibriopersonalhoy.com/cart/46514378342558:1" className="inline-block font-body font-semibold text-warm-dark bg-amber hover:bg-amber-light px-8 py-4 rounded-lg text-base transition-all duration-300 hover:shadow-amber-glow active:scale-[0.97]" data-id="element-45">
              ¡Quiero Mi Guía Ahora!
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}